var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEtage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    width: "251.62mm",
    height: "265.16mm",
    viewBox: "0 0 951 1002.1776",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m116.5 0.67765v958h-116v43h950v-43h-116l-0.99-733.3zm675 256v702h-294v-105h-44v105h-294v-900zm-529 71v43h84v-43zm171 0v43h84v-43zm171 0v43h84v-43zm-342 126v44h84v-44zm171 0v44h84v-44zm171 0v44h84v-44zm-342 129v43h84v-43zm171 0v43h84v-43zm171 0v43h84v-43zm-342 129v43h84v-43zm171 0v43h84v-43zm171 0v43h84v-43z",
    stroke: "none"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEtage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/etage.f32d4217.svg";
export { ForwardRef as ReactComponent };